import { LG } from "./liquidGlass";

export const TEXTFIELD_STYLES = {
  standard: {
    "& .MuiOutlinedInput-root": {
      borderRadius: LG.radius.sm,
      fontFamily: "inherit",
      fontSize: "0.875rem",
      background: LG.color.surface,
      backdropFilter: LG.blurLight,
      WebkitBackdropFilter: LG.blurLight,
      "& fieldset": { border: `1px solid ${LG.color.border}`, borderRadius: LG.radius.sm },
      "&:hover fieldset": { border: `1px solid ${LG.color.borderStrong}` },
      "&.Mui-focused fieldset": { border: `1.5px solid ${LG.color.text}` },
    },
    "& .MuiInputBase-input": {
      color: LG.color.text,
      "&::placeholder": { color: LG.color.textSecondary, opacity: 1 },
    },
  },
  search: {
    "& .MuiOutlinedInput-root": {
      borderRadius: LG.radius.pill,
      fontFamily: "inherit",
      background: LG.color.surface,
      backdropFilter: LG.blurLight,
      WebkitBackdropFilter: LG.blurLight,
      "& fieldset": { border: `1px solid ${LG.color.border}`, borderRadius: LG.radius.pill },
      "&:hover fieldset": { border: `1px solid ${LG.color.borderStrong}` },
      "&.Mui-focused fieldset": { border: `1.5px solid ${LG.color.text}` },
    },
    "& .MuiInputBase-input": {
      color: LG.color.text,
      "&::placeholder": { color: LG.color.textSecondary, opacity: 1 },
    },
  },
} as const;
